import axios from 'axios';
import { resolveApiBase } from './api';

// Public capabilities must not inherit a staff login or selected restaurant.
export const publicMenuApi = axios.create({ baseURL: resolveApiBase() });
export const menuHeaders = (access: string, guestAccess?: string) => ({
  'X-Menu-Access': access,
  ...(guestAccess ? { 'X-Guest-Access': guestAccess } : {}),
});

export const publicOrderKey = (orderId: number) => `public-order-access:${orderId}`;
